<template>
    <div class="bg-white text-black">
        <Mainlayout></Mainlayout>
        <br /><br /><br />
            <div>
                <CCol sm="12" class="bg-white">
            <br /><br /><br />
            <CCol sm="12" style="width: 80%;background-size: cover; margin: auto;color: #fff">
                <br /><br /><br />
                <CRow class="">
                    <CCol sm="8">
                        <CCard class="bg-white border-grey-card">

                            {{ user.name }}
                            <CRow class="p-20 m-3">
                                <CCol sm="2">
                                    <span>
                                <img
                                  v-if="studentProfileAuthorize == ''"
                                  width="80px"
                                  height="80px"
                                  src="../assets/img/defaultuser.png"
                                />
                                <img
                                  v-else
                                  width="80px"
                                  height="80px"
                                  :src="photoURL"
                                  style="border-radius: 50%; border: 5px solid #fff"
                                />
                              </span>
                                </CCol>
                                <CCol sm="8">
                                    <h1 class="custom-28px-700 text-black text-left">
                                        <strong>{{ user.name }}</strong>
                                    </h1>
                                    <label class="label-custom-header-subtitle">{{ user.userType }}</label>
                                </CCol>
                                <CCol sm="2">
                                    <CButton class="button-Explore-dark bg-main-blue" style="width:50%;background-color: #027DEF;width:100px"><span class="ml-2 mr-2 text-white">Setting</span></CButton>
                                </CCol>
                            </CRow>
    
    
                            <br /><br />
                        </CCard>
                    </CCol>
                    <CCol sm="4">
                        <CCard class="card-grey p-40 b-20" style="border:none">
                          <h3 class="custom-20px-700 mt-2 text-black">My Account</h3>
                        <span class="text-black"> <img src="../assets/img/location1.png" style="width:30px"/> Kuala Lumpur </span> <br />
                        <span class="text-black"> <img src="../assets/img/earth.png" style="width:30px"/> English, Melayu Malaysia </span>
    
                        <h3 class="custom-20px-700 mt-4 text-black">Connect</h3>
                        <span class="text-black"> <img src="../assets/img/Message.png" style="width:30px"/> {{ user.email}}</span> <br />
                   <br /><br />
                        </CCard>
                    </CCol>
                </CRow>
    
            </CCol>

          
    
        </CCol>

        <CCol sm="12" style="background-size: cover; margin: auto;background-color: #F5F5F5">
            <CCol sm="12" style="width: 80%;background-size: cover; margin: auto;">
                <br /><br />
                <h3 class="custom-48px-600">History Purchased</h3>
                <br /><br />
                <CCol sm="12" v-for="item in purchase" v-bind:key="item.Id">
                    <CCard>
                        <CRow>
                            <CCol sm="2">
                                <img
                                  v-if="studentProfileAuthorize == ''"
                                  width="80px"
                                  height="80px"
                                  src="../assets/img/defaultuser.png"
                                  class="m-2"
                                />
                                <img
                                  v-else
                                  width="80px"
                                  height="80px"
                                  :src="photoURL"
                                  class="m-2"
                                  style="border-radius: 50%; border: 5px solid #fff"
                                />
                            </CCol>
                            <CCol sm="8"><p class="custom-20px-700 mt-3">{{ user.name }}</p>
                                <p class="custom-12px-400">Description: {{ item.Description }}</p>
                                <p class="custom-12px-400">Purchased On: {{ item.TransactionDate | moment("DD MMM YYYY hh:mm:ss") }}</p></CCol>
                            <CCol sm="2">
                                <div class="text-center mt-4">
                                <span class="success-paid" v-if="item.Status === true">Paid</span>
                                <br />
                                <label class="custom-20px-600 mt-3">RM {{ item.Total}}</label>
                            </div>
                           </CCol>
                        </CRow>
                    </CCard>

                </CCol>
                </CCol>
                </CCol>
            </div>
        <FooterLayout></FooterLayout>
    </div>
</template>



<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);


import Mainlayout from "../containers/AllHeaderLanding.vue";
import Footerlayout from "../containers/TheFooter.vue";


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout
    },

    data() {
        return {
            studentProfileAuthorize: "",
            user: {},
            purchase: [],

        };
    },

    async mounted() {
        let isAuth = await this.UserAuth();

        if (isAuth) {
            this.Busy = false;
            this.GetInfoUser();
        } else {
            this.GoToLogin();
        }
    },
    methods: {
        GoToLogin() {
            this.$router.push("SignInUserAffiliate");
        },
        GetInfoUser() {
            return this.$API
                .get(this.$LoginUserDetailWebs, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.user = response.data;
                        this.GetAuthorizeProfile(this.user.id);
                        this.GetRecentPurchase(this.user.id);
                    }
                });
        },
        GetAuthorizeProfile() {
            this.$API
                .get(this.$GetProfilePhotoAuthorize + "?userId=" + this.user.id, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.studentProfileAuthorize = response.data;
                        this.photoURL =
                            "https://pickiddo.com" + this.studentProfileAuthorize;
                    }
                });
        },

        GetRecentPurchase() {
            return this.$API
            .get(this.$GetDetailRecentPurchase + "?userId=" + this.user.id, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.purchase = response.data;
                    }
                });
        },
    }

};
</script>

<style scoped>

@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");
    
.c-header {
  /* background: rgb(23, 77, 124);
  background: linear-gradient(92deg, #174d7c, #1b7682);
  border-bottom: 0.01px solid #1a6783;
  border-bottom: 1px solid #636f83; */
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  border-bottom: 0;
  border-bottom: 0;
  /* color: #fff; */
}
.c-app{
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  font-family: 'Montserrat', sans-serif;
}
body {
  font-family: "Montserrat", sans-serif;
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
    font-family: "Montserrat", sans-serif;
}
label
{
  font-family: "Montserrat", sans-serif;
}

body nav.onScroll {
  box-shadow: 0 0 10px #aaa;
  background-color: rgb(255, 255, 255);
  font-family: 'Montserrat';
font-style: normal;
}
body nav.onScroll ul li {
  color: #10b761;
}
body nav ul {
  margin-left: 3em;
  width: 25%;
  display: flex;
  justify-content: space-between;
}
body nav ul li {
  cursor: pointer;
  font-weight: 600;
  list-style-type: none;
  color: white;
}
body {
    top: 0 !important;
    font-family: 'Montserrat', sans-serif;
}
</style>